// language=SQL format=false
export const v1UpgradeStatements = [
    `CREATE TABLE IF NOT EXISTS users (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        external_id TEXT NOT NULL UNIQUE,
        name TEXT NOT NULL,
        email TEXT UNIQUE,
        bu TEXT
     );`,
    `CREATE TABLE IF NOT EXISTS stores (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT NOT NULL UNIQUE,
         name TEXT NOT NULL,
         latitude TEXT,
         longitude TEXT,
         crates INTEGER NOT NULL DEFAULT 0,
         contact_name TEXT,
         contact_phone TEXT,
         contact_email TEXT,
         address_line_1 TEXT,
         address_line_2 TEXT,
         province TEXT,
         city TEXT,
         postal_code TEXT,
         is_check_in_only INTEGER NOT NULL DEFAULT 0
     );`,
    `CREATE TABLE IF NOT EXISTS no_delivery_reasons (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT UNIQUE,
         name TEXT NOT NULL
     );`,
    `CREATE TABLE IF NOT EXISTS payment_methods (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT UNIQUE,
         name TEXT NOT NULL,
         is_payment_reference_required INTEGER NOT NULL DEFAULT 1
     );`,
    `CREATE TABLE IF NOT EXISTS return_reasons (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT UNIQUE,
         name TEXT NOT NULL
     );`,
    `CREATE TABLE IF NOT EXISTS product_categories (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT UNIQUE,
         name TEXT NOT NULL UNIQUE
     );`,
    `CREATE TABLE IF NOT EXISTS products (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         product_category_id INTEGER,
         external_id TEXT NOT NULL UNIQUE,
         name TEXT NOT NULL,
         price TEXT NOT NULL,
         barcode TEXT,
         image_path TEXT,
         sort_order INTEGER,
         bu TEXT,
         FOREIGN KEY (product_category_id) REFERENCES product_categories (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE
     );`,
    `CREATE TABLE IF NOT EXISTS routes (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT NOT NULL UNIQUE,
         name TEXT NOT NULL
     );`,
    `CREATE TABLE IF NOT EXISTS active_routes (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         route_id INTEGER NOT NULL,
         user_id INTEGER NOT NULL,
         start_date TEXT NOT NULL,
         end_date TEXT,
         FOREIGN KEY (route_id) REFERENCES routes (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
         FOREIGN KEY (user_id) REFERENCES users (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE
     );`,
    `CREATE INDEX active_routes_route_id_index ON active_routes (route_id);`,
    `CREATE INDEX active_routes_user_id_index ON active_routes (user_id);`,
    `CREATE TABLE IF NOT EXISTS route_store_user (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         route_external_id TEXT NOT NULL,
         store_external_id TEXT NOT NULL,
         user_external_id TEXT,
         sort_order INTEGER NOT NULL DEFAULT 0,
         created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
     );`,
    `CREATE INDEX route_store_user_route_external_id_index ON route_store_user (route_external_id);`,
    `CREATE INDEX route_store_user_store_external_id_index ON route_store_user (store_external_id);`,
    `CREATE INDEX route_store_user_user_external_id_index ON route_store_user (user_external_id);`,
    `CREATE UNIQUE INDEX route_store_user_unique
         ON route_store_user (
            route_external_id,
            store_external_id
    );`,
    `CREATE TABLE IF NOT EXISTS check_ins (
        id INTEGER PRIMARY KEY AUTOINCREMENT,
        route_id INTEGER NOT NULL,
        store_id INTEGER NOT NULL,
        user_id INTEGER NOT NULL,
        check_in TEXT NOT NULL,
        check_out TEXT,
        no_delivery_reason_id INTEGER,
        no_delivery_notes TEXT,
        latitude TEXT,
        longitude TEXT,
        FOREIGN KEY (route_id) REFERENCES routes (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
        FOREIGN KEY (store_id) REFERENCES stores (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
        FOREIGN KEY (user_id) REFERENCES users (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
        FOREIGN KEY (no_delivery_reason_id) REFERENCES no_delivery_reasons (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE
     );`,
    `CREATE INDEX check_ins_route_id_index ON check_ins (route_id);`,
    `CREATE INDEX check_ins_store_id_index ON check_ins (store_id);`,
    `CREATE INDEX check_ins_user_id_index ON check_ins (user_id);`,
    `CREATE INDEX check_ins_no_delivery_reason_id_index ON check_ins (no_delivery_reason_id);`,
    `CREATE TABLE IF NOT EXISTS cart_items (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         check_in_id INTEGER NOT NULL,
         product_id INTEGER NOT NULL,
         user_id INTEGER NOT NULL,
         store_id INTEGER NOT NULL,
         route_id INTEGER NOT NULL,
         price TEXT NOT NULL,
         quantity INTEGER NOT NULL,
         FOREIGN KEY (check_in_id) REFERENCES check_ins (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
         FOREIGN KEY (product_id) REFERENCES products (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
    FOREIGN KEY (user_id) REFERENCES users (id)
    ON DELETE RESTRICT
    ON UPDATE CASCADE,
    FOREIGN KEY (store_id) REFERENCES stores (id)
    ON DELETE RESTRICT
    ON UPDATE CASCADE,
    FOREIGN KEY (route_id) REFERENCES routes (id)
    ON DELETE RESTRICT
    ON UPDATE CASCADE
     );`,
    `CREATE TABLE IF NOT EXISTS return_items (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         check_in_id INTEGER NOT NULL,
         product_id INTEGER NOT NULL,
         user_id INTEGER NOT NULL,
         store_id INTEGER NOT NULL,
         route_id INTEGER NOT NULL,
         return_reason_id INTEGER,
         price TEXT NOT NULL,
         quantity INTEGER NOT NULL,
         FOREIGN KEY (check_in_id) REFERENCES check_ins (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
         FOREIGN KEY (product_id) REFERENCES products (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
     FOREIGN KEY (return_reason_id) REFERENCES return_reasons (id)
            ON DELETE RESTRICT
            ON UPDATE CASCADE,
    FOREIGN KEY (user_id) REFERENCES users (id)
    ON DELETE RESTRICT
    ON UPDATE CASCADE,
    FOREIGN KEY (store_id) REFERENCES stores (id)
    ON DELETE RESTRICT
    ON UPDATE CASCADE,
    FOREIGN KEY (route_id) REFERENCES routes (id)
    ON DELETE RESTRICT
    ON UPDATE CASCADE
     );`,
    `CREATE TABLE IF NOT EXISTS price_lists (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id TEXT,
         product_external_id TEXT NOT NULL,
         store_external_id TEXT,
         route_external_id TEXT NOT NULL,
         price TEXT NOT NULL
     );`,
    `CREATE TABLE IF NOT EXISTS payments (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         check_in_id INTEGER NOT NULL,
         user_id INTEGER NOT NULL,
         store_id INTEGER NOT NULL,
         route_id INTEGER NOT NULL,
         payment_method_id INTEGER,
         payment_reference TEXT,
         preordered_total TEXT,
         order_total TEXT,
         returns_total TEXT,
         amount_paid TEXT,
         given_crates INTEGER NOT NULL DEFAULT 0,
         returned_crates INTEGER NOT NULL DEFAULT 0,
         status TEXT NOT NULL DEFAULT 'draft',
         created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
     );`,
    `CREATE UNIQUE INDEX check_in_id_user_id_store_id_route_id_payments_unique
         ON payments (
            check_in_id,
            user_id,
            store_id,
            route_id
    );`,
    `CREATE TABLE IF NOT EXISTS preordered_items (
         id INTEGER PRIMARY KEY AUTOINCREMENT,
         external_id INTEGER,
         store_external_id TEXT NOT NULL,
         route_external_id TEXT NOT NULL,
         product_external_id TEXT NOT NULL,
         quantity INTEGER NOT NULL,
         price TEXT NOT NULL,
         created_at TEXT NOT NULL DEFAULT CURRENT_TIMESTAMP
     );`,
    `CREATE INDEX preordered_items_store_external_id_index ON preordered_items (store_external_id);`,
    `CREATE INDEX preordered_items_route_external_id_index ON preordered_items (route_external_id);`,
    `CREATE INDEX preordered_items_product_external_id_index ON preordered_items (product_external_id);`,
];
